import React from "react";
import {SeatDeckType} from "@CheckOrder/components/MainSection/SeatPicker/types/SeatDeck.type";
import SeatRow from "@CheckOrder/components/MainSection/SeatPicker/components/SeatRow";
import SeatHeader from "@CheckOrder/components/MainSection/SeatPicker/components/SeatHeader";
import {useAppSelector} from "@Hooks/selector/useAppSelector";

type SeatDeckProps = {
    seatDeck: SeatDeckType,
    isReturn: boolean,
    displayCorridors: boolean
}

function SeatDeck({seatDeck, isReturn, displayCorridors}: SeatDeckProps) {
    const seatColumnLength = seatDeck.seatRows[0].seats.length
    const corridorIndex = Math.floor(seatColumnLength / 2)

    return (
        <div className="gb--seat-picker-seats">
            <SeatHeader
                displayCorridors={displayCorridors}
                corridorIndex={corridorIndex}
                seatColumnLength={seatColumnLength}
            />
            {seatDeck.seatRows.map((seatRow, index) => (
                <SeatRow
                    displayCorridors={displayCorridors}
                    isReturn={isReturn}
                    corridorIndex={corridorIndex}
                    key={seatRow.key}
                    seatRow={seatRow}
                    rowIndex={index}
                />
            ))}
        </div>
    );
}

export default SeatDeck;